const parseKeywordList = (raw) =>
  String(raw || "")
    .split(",")
    .map((k) => k.trim().toLowerCase())
    .filter(Boolean);

export const isSendToClientHiddenForProject = (projectName) => {
  const keywords = parseKeywordList(
    process.env.REACT_APP_HIDE_SEND_TO_CLIENT_PROJECT_KEYWORDS,
  );
  if (!keywords.length || !projectName) return false;
  const name = String(projectName).toLowerCase();
  return keywords.some((keyword) => name.includes(keyword));
};
